export default __webpack_public_path__ + "static/media/israel.03da2314.jpg";